import { create } from "zustand";

interface SaveStatusState {
  isSaving: boolean;
  setIsSaving: (value: boolean) => void;
}

// Bridges useSaveAllSections's aggregate isSaving state up to FooterAction,
// which lives outside the save orchestrator (as a sibling in ReviewPage) and
// has no direct access to the mutation instance. Prevents a double-submit
// from a second click while the first save is still in flight.
export const useSaveStatusStore = create<SaveStatusState>((set) => ({
  isSaving: false,
  setIsSaving: (value: boolean) => set({ isSaving: value }),
}));
